"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnownKeys = void 0;
const tslib_1 = require("tslib");
const path_1 = tslib_1.__importDefault(require("path"));
const constructs_1 = require("../../model/constructs");
const lambda_1 = require("../lambda");
const outptutFns_1 = require("./outptutFns");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
/**
 * maintains an memory and locally persisted nodeEdgeMapper, hydrates on calling hydrate if file exists
 */
class KnownKeys {
    constructor({ absoluteFilePath, fileName }) {
        this.isHydrated = false;
        this.clear = () => {
            this.nodeEdgeMapper = new constructs_1.NodeEdgeMapper();
        };
        this.hydrate = async () => {
            const nodeMapperZombieRes = await (0, outptutFns_1.readObjectFromPath)(this.absoluteFilePath, this.fileName);
            if (nodeMapperZombieRes.data) {
                this.nodeEdgeMapper = new constructs_1.NodeEdgeMapper(nodeMapperZombieRes.data);
                this.isHydrated = true;
                debug && console.log(`Hydrated nodeEdgeMapper from ${path_1.default.join(this.absoluteFilePath, this.fileName)}`);
                debug && console.log(this.nodeEdgeMapper.containedTypes());
            }
            else {
                console.log(`Error hydrating known keys store`, nodeMapperZombieRes.err?.message);
                await this.persist();
            }
        };
        this.persist = async () => {
            debug && console.log(`persisting to ${this.absoluteFilePath}/${this.fileName}`);
            const persistRes = await (0, outptutFns_1.outputToPath)(this.absoluteFilePath, this.fileName, this.nodeEdgeMapper);
            if (persistRes.err) {
                throw new Error(`Err is persist,${persistRes.err.message}`);
            }
        };
        this.addItemToKnownKeys = (item) => {
            this.nodeEdgeMapper.loadItem(item);
            if (!this.isHydrated) {
                debug && console.log(`KnownKeys is not hydrated`);
            }
        };
        this.addItemsToKnownKeys = (items) => items.forEach((item) => this.addItemToKnownKeys(item));
        this.isKnownKey = (item) => this.nodeEdgeMapper.itemExists(item);
        this.nodeEdgeMapper = new constructs_1.NodeEdgeMapper();
        this.fileName = fileName;
        this.absoluteFilePath = absoluteFilePath;
    }
}
exports.KnownKeys = KnownKeys;
